// FHT Swagger jQuery client V2

/**
 * FHT.Common.Types.CompanyMembershipType, FHT.Common.Types, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 */

/**
* FHT.Common.Types.CompanyMembershipType, FHT.Common.Types, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
*/
// mark 1 model enum
export var CompanyMembershipTypeEnum;

(function (CompanyMembershipTypeEnum) {
  CompanyMembershipTypeEnum["None"] = "None";
  CompanyMembershipTypeEnum["General"] = "General";
  CompanyMembershipTypeEnum["Gold"] = "Gold";
  CompanyMembershipTypeEnum["Silver"] = "Silver";
  CompanyMembershipTypeEnum["FhtMember"] = "FhtMember";
  CompanyMembershipTypeEnum["FHT1VIP_905"] = "FHT1VIP_905";
  CompanyMembershipTypeEnum["FHT1VIP_906"] = "FHT1VIP_906";
  CompanyMembershipTypeEnum["FHT1VIP_908"] = "FHT1VIP_908";
  CompanyMembershipTypeEnum["FHT1VIP_912"] = "FHT1VIP_912";
  CompanyMembershipTypeEnum["FHT1VIP_918"] = "FHT1VIP_918";
  CompanyMembershipTypeEnum["FHT1VIP_922"] = "FHT1VIP_922";
  CompanyMembershipTypeEnum["FHT1VIP_925"] = "FHT1VIP_925";
  CompanyMembershipTypeEnum["FHT1VIP_935"] = "FHT1VIP_935";
  CompanyMembershipTypeEnum["FHT1VIP_937"] = "FHT1VIP_937";
  CompanyMembershipTypeEnum["FHT1VIP_941"] = "FHT1VIP_941";
  CompanyMembershipTypeEnum["FHT1VIP_942"] = "FHT1VIP_942";
  CompanyMembershipTypeEnum["FHT1VIP_947"] = "FHT1VIP_947";
  CompanyMembershipTypeEnum["FHT1VIP_949"] = "FHT1VIP_949";
  CompanyMembershipTypeEnum["FHT1VIP_950"] = "FHT1VIP_950";
  CompanyMembershipTypeEnum["FHT1VIP_951"] = "FHT1VIP_951";
  CompanyMembershipTypeEnum["FHT1VIP_952"] = "FHT1VIP_952";
  CompanyMembershipTypeEnum["FHT1VIP_958"] = "FHT1VIP_958";
  CompanyMembershipTypeEnum["FHT1VIP_959"] = "FHT1VIP_959";
  CompanyMembershipTypeEnum["FHT1VIP_960"] = "FHT1VIP_960";
  CompanyMembershipTypeEnum["FHT1VIP_963"] = "FHT1VIP_963";
  CompanyMembershipTypeEnum["FHT1VIP_964"] = "FHT1VIP_964";
  CompanyMembershipTypeEnum["FHT1VIP_965"] = "FHT1VIP_965";
  CompanyMembershipTypeEnum["FHT1VIP_966"] = "FHT1VIP_966";
  CompanyMembershipTypeEnum["FHT1VIP_968"] = "FHT1VIP_968";
  CompanyMembershipTypeEnum["FHT1VIP_969"] = "FHT1VIP_969";
  CompanyMembershipTypeEnum["FHT1VIP_970"] = "FHT1VIP_970";
  CompanyMembershipTypeEnum["FHT1VIP_971"] = "FHT1VIP_971";
  CompanyMembershipTypeEnum["FHT1VIP_972"] = "FHT1VIP_972";
  CompanyMembershipTypeEnum["FHT1VIP_973"] = "FHT1VIP_973";
})(CompanyMembershipTypeEnum || (CompanyMembershipTypeEnum = {}));